export enum FeatureType {
  CngApi = '@cng/api',
  CngSlice = '@cng/slice',
  P360Api = '@p360/api',
  P360Slice = '@p360/slice',
}
